// KPI Builder — how answers and queries are stored.
import { BuilderAnswers, BuilderConfig, QueryObject } from './types';

export function snapshotOf(a: BuilderAnswers, cumulative: boolean): BuilderConfig['builder'] {
  return {
    recipe: a.recipe, source: a.src, sourceB: a.srcB, learnerGroups: a.segs, measure: a.measure, groupBy: a.group, topN: a.topN, minCount: a.minCount,
    interval: a.interval, cumulative, rateGroup: a.rateSeg, columns: a.cols, rows: a.rows, kpiFilters: a.kpiFilters, funnel: a.funnel, questionKind: a.questionKind, progressKind: a.progressKind, readyKind: a.readyKind, threshold: a.threshold, extras: a.extras, advanced: a.advanced, custom: a.custom,
  };
}

/** The stored form of a query list: requestQueryMap and aggrQuery are JSON strings. */
export const toQueryString = (queries: QueryObject[]): string =>
  JSON.stringify(queries.map((q) => ({ ...q, requestQueryMap: JSON.stringify(q.requestQueryMap), aggrQuery: JSON.stringify(q.aggrQuery) })));
